import { useRootStore } from './useRootStore';

export function useAllPrizesPageStore() {
  const { allPrizesPageStore } = useRootStore();
  return allPrizesPageStore;
}
